import { render, staticRenderFns } from "./LFixedBtn.vue?vue&type=template&id=243668af&scoped=true"
import script from "./LFixedBtn.vue?vue&type=script&lang=js"
export * from "./LFixedBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243668af",
  null
  
)

export default component.exports